// extracted by mini-css-extract-plugin
module.exports = {"vRadius":"10px","menu":"StickersMenu_menu__2iVzl"};